document.addEventListener("DOMContentLoaded", function () {
  console.log('AAAAAA')

  const megaMenuItems = document.querySelectorAll('.header__mega_menu_li');

  megaMenuItems.forEach(item => {
    item.addEventListener('mouseenter', function() {
      const subMenu = this.querySelector('.header__mega_sub_menu');
      if (subMenu) {
        const subMenuRightEdge = subMenu.getBoundingClientRect().right;
        const viewportWidth = window.innerWidth;

        if (subMenuRightEdge > viewportWidth) {
          subMenu.classList.add('header__mega_sub_menu--left');
        } else {
          subMenu.classList.remove('header__mega_sub_menu--left');
        }
      }
    });

    item.addEventListener('mouseleave', function() {
      const subMenu = this.querySelector('.header__mega_sub_menu');
      if (subMenu) {
        // Remove positioning adjustment when not hovered
        subMenu.classList.remove('header__mega_sub_menu--left');
      }
    });
  });
});
